import { Component } from 'vue-property-decorator'
import Vue from 'vue'

@Component
export class AddCommaAndSpace extends Vue {
    addCommaAndSpace(array: IPlaylist[] | IProducer[] | IDeal[], index: number) {
        const hasCommaAndSpace = array.length > 1 && index !== array.length - 1
        return hasCommaAndSpace ? ',&nbsp' : ''
    }
}
